import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { API_ENDPOINTS } from "../config/api";
import { removeUser, getUser } from "../utils/auth";
import axiosInstance from "../utils/axios";

const Sidebar = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const user = getUser();

  const handleMouseEnter = () => {
    setIsExpanded(true);
  };

  const handleMouseLeave = () => {
    setIsExpanded(false);
  };

  const handleLogout = async () => {
    try {
      // Call logout API - cookie will be cleared by backend
      await axiosInstance.post(API_ENDPOINTS.LOGOUT);
    } catch (error) {
      console.error("Logout error:", error);
    } finally {
      // Remove user data from localStorage (cookie is cleared by backend)
      removeUser();
      navigate("/login", { replace: true });
    }
  };

  const menuItems = [
    {
      id: "dashboard",
      icon: "/icons/twin.svg",
      label: "Dashboard",
      path: "/dashboard",
    },
  ];

  return (
    <div
      className="fixed left-0 top-0 h-full flex flex-col z-50 transition-all duration-300"
      style={{
        backgroundColor: "#175CD3",
        width: isExpanded ? "256px" : "64px",
      }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {/* Logo */}
      <div className="py-6 px-2 border-b" style={{ borderColor: "rgba(255, 255, 255, 0.1)" }}>
        <div className="flex items-center justify-center w-full">
          {isExpanded ? (
            <img src="/icons/logo full white.svg" alt="UPU" style={{ height: "40px" }} />
          ) : (
            <img src="/icons/logo only.svg" alt="UPU" style={{ height: "40px", width: "auto" }} />
          )}
        </div>
      </div>

      {/* Menu Items */}
      <div className="px-2 space-y-1 mt-4 flex-1">
        {menuItems.map((item) => (
          <Link
            key={item.id}
            to={item.path}
            className="flex items-center rounded-lg transition-colors duration-200 w-full"
            style={{
              backgroundColor: location.pathname === item.path ? "rgba(255, 255, 255, 0.1)" : "transparent",
              color: "white",
              padding: "12px",
              justifyContent: isExpanded ? "flex-start" : "center",
            }}
          >
            <img src={item.icon} alt={item.label} className="w-5 h-5" style={{ filter: "brightness(0) invert(1)" }} />
            {isExpanded && <span className="font-medium ml-3">{item.label}</span>}
          </Link>
        ))}
      </div>

      {/* User Info and Logout */}
      <div className="px-2 pb-4 border-t" style={{ borderColor: "rgba(255, 255, 255, 0.1)" }}>
        {isExpanded && user && (
          <div className="py-3 px-2 text-white text-sm">
            <div className="font-medium truncate">{user.name} {user.lastName}</div>
            <div className="text-xs opacity-75 truncate">{user.email}</div>
          </div>
        )}
        <button
          onClick={handleLogout}
          className="flex items-center rounded-lg transition-colors duration-200 w-full hover:bg-opacity-10 hover:bg-white"
          style={{
            color: "white",
            padding: "12px",
            justifyContent: isExpanded ? "flex-start" : "center",
          }}
          title="Logout"
        >
          <svg
            className="w-5 h-5"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            style={{ filter: "brightness(0) invert(1)" }}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
            />
          </svg>
          {isExpanded && <span className="font-medium ml-3">Logout</span>}
        </button>
      </div>
    </div>
  );
};

export default Sidebar;
